module.exports = __webpack_public_path__ + "img/refrigerating1.png";